import 'regenerator-runtime';
import { yiluEnv, renderYiluApp, routes } from '@yiluhub/travel-integration';

import { overrides } from './overrides/map';
import { iconOverrides } from './overrides/icons';

import './styles/index.scss';

import packageJson from '../package.json';

yiluEnv.setVariables({
  YILU_SIMPLETRIP_VERSION: packageJson.dependencies['@yiluhub/travel-integration'],
  YILU_API_PRODUCTION_ENVIRONMENT: import.meta.env.VITE_YILU_API_PRODUCTION_ENVIRONMENT,
  GOOGLE_MAPS_KEY: import.meta.env.VITE_GOOGLE_MAPS_KEY,
  GOOGLE_ANALYTICS_MEASUREMENT_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  GOOGLE_TAG_MANAGER_CONTAINER_ID: import.meta.env.VITE_GOOGLE_TAG_MANAGER_CONTAINER_ID,
  HOTJAR_ID: import.meta.env.VITE_HOTJAR_ID,
  LOCALES_HOST_URL: import.meta.env.VITE_LOCALES_HOST_URL,
  PHONE_COUNTRY_CODE: import.meta.env.VITE_PHONE_COUNTRY_CODE,
  YILU_ENTERPRISE_PARTNER: import.meta.env.VITE_YILU_ENTERPRISE_PARTNER,
  FAQ_TYPE_FORM_EN: 'PYMFNZzF',
  FAQ_TYPE_FORM_DE: 'HJmEbrU2',
  YILU_EMBEDDED_TI: import.meta.env.VITE_YILU_EMBEDDED_TI,
  YILU_MEILI_PTID: import.meta.env.VITE_YILU_MEILI_PTID,
  YILU_MEILI_MANAGE_ENABLED: import.meta.env.VITE_YILU_MEILI_MANAGE_ENABLED,
  YILU_MEILI_MANAGE_PTID: import.meta.env.VITE_YILU_MEILI_MANAGE_PTID,
  // AMP envs
  YILU_AMP_BACKEND_URL: import.meta.env.VITE_YILU_AMP_BACKEND_URL,
  YILU_AMP_STORE_ID: import.meta.env.VITE_YILU_AMP_STORE_ID,
  YILU_AMP_LOUNGE_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_LOUNGE_VERTICAL_ID,
  YILU_AMP_PARKING_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_PARKING_VERTICAL_ID,
  YILU_AMP_AIRPORT_TRANSFER_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_AIRPORT_TRANSFER_VERTICAL_ID,
  YILU_AMP_AIRPORT_TRANSFER_PASSES_VERTICAL_ID: import.meta.env
    .VITE_YILU_AMP_AIRPORT_TRANSFER_PASSES_VERTICAL_ID,
  YILU_AMP_EURAIL_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_EURAIL_VERTICAL_ID,
  YILU_AMP_RIDES_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_RIDES_VERTICAL_ID,
  YILU_AMP_CAR_RENTAL_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_CAR_RENTAL_VERTICAL_ID,
  YILU_AMP_LOUNGE_CATALOG_ID: import.meta.env.VITE_YILU_AMP_LOUNGE_CATALOG_ID,
  YILU_AMP_MEILI_CATALOG_ID: import.meta.env.VITE_YILU_AMP_MEILI_CATALOG_ID,
  YILU_MEILI_ALLOWED_HOSTS: import.meta.env.VITE_YILU_MEILI_ALLOWED_HOSTS,
  YILU_EURAIL_COUNTRY_PRIORITY_LIST: import.meta.env.VITE_EURAIL_COUNTRY_PRIORITY_LIST,
  YILU_AMP_EURAIL_COUNTRY_PASS_CATALOG_ID: import.meta.env.VITE_YILU_AMP_EURAIL_COUNTRY_PASS_CATALOG_ID,
  YILU_AMP_EURAIL_GLOBAL_PASS_CATALOG_ID: import.meta.env.VITE_YILU_AMP_EURAIL_GLOBAL_PASS_CATALOG_ID,
});

renderYiluApp({
  overrides,
  iconOverrides,
  defaultPath: routes.LOUNGES_SEARCH,
});
